import { ChangeDetectionStrategy, Component, input, output, computed } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { cueQrCode, cueClock, cueUser, IconComponent } from '@cue/ui/icons';
import { ImageWidthPipe, LocalizedStringPipe } from '@cue/utilities';
import { DatePipe, NgStyle } from '@angular/common';
import { EventData, NavigationResourceBasicInfoWithFirstLetter } from '@cue/data';
import { QRCategoryItemModel } from '@cue/api';
import { CategoryIconPipe } from '../../pipes/category-icon.pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';

@Component({
  selector: 'cue-resource-event-detail',
  templateUrl: './resource-event-detail.component.html',
  styleUrls: ['./resource-event-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    IconComponent,
    ImageWidthPipe,
    LocalizedStringPipe,
    NgStyle,
    DatePipe,
    CategoryIconPipe,
    TranslocoPipe,
  ],
  animations: [],
})
export class ResourceEventDetailComponent {
  protected ICONS = {
    cueQrCode,
    cueUser,
    cueClock,
  };
  categories = input.required<QRCategoryItemModel[]>();
  item = input.required<NavigationResourceBasicInfoWithFirstLetter>();

  requestNavigate = output<MouseEvent>();

  eventDataList = computed<EventData[]>(() => {
    return this.item().eventData;
  });

  currentEvent = computed<EventData | null>(() => {
    const currentDate = new Date(Date.now());
    if (
      this.eventDataList().length > 0 &&
      this.eventDataList()[0].realStart <= currentDate &&
      this.eventDataList()[0].realEnd >= currentDate
    ) {
      console.log(this.eventDataList()[0]);
      return this.eventDataList()[0];
    }
    return null;
  });

  freeTillDate = computed<Date | null>(() => {
    if (this.currentEvent() === null && this.eventDataList().length > 0) {
      return this.eventDataList()[0].realStart;
    }
    return null;
  });
  protected readonly translation = translation;
}
